import type { JsonSchemaNode } from "@nmblr-platform-flow/schema";
import { useState } from "react";
import { humanize } from "../../../lib/humanize.js";

interface Props {
	name: string;
	schema: JsonSchemaNode;
	value: unknown;
	onChange: (value: unknown) => void;
	required?: boolean;
}

export function SecretInput({ name, schema, value, onChange, required }: Props) {
	const [visible, setVisible] = useState(false);
	const id = `field-${name}`;
	return (
		<label className="mb-3 block" htmlFor={id}>
			<span className="text-xs text-text-muted">
				{humanize(name)}
				{required && <span className="ml-1 text-error">*</span>}
			</span>
			<div className="relative mt-1">
				<input
					id={id}
					type={visible ? "text" : "password"}
					value={typeof value === "string" ? value : ""}
					onChange={(e) => onChange(e.target.value)}
					className="block w-full rounded-xl border border-border bg-canvas px-3 py-2 pr-10 font-mono text-xs text-text-primary focus:border-accent focus:ring-1 focus:ring-accent focus:outline-none"
				/>
				<button
					type="button"
					aria-label="Toggle visibility"
					onClick={() => setVisible((v) => !v)}
					className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-text-muted hover:text-text-primary"
				>
					{visible ? "Hide" : "Show"}
				</button>
			</div>
			{schema.description && (
				<span className="mt-1 block text-xs text-text-muted">{schema.description}</span>
			)}
			<span className="mt-0.5 block text-xs text-text-muted/60">
				Stored as a Forge secret. Value is encrypted at rest.
			</span>
		</label>
	);
}
